import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  invoice?: IInvoice;
};

export function getWorkLogPayeeStatusCellProps({
  workLog,
  invoice
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: invoice
          ? `Invoiced #${invoice.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    // TODO: Handle "InProgress" status when backend adds it
    // "InProgress" means returned for corrections by payer
    case "InProgress" as WorkLogStatus:
      return {
        secondaryText: "Returned for corrections",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert-circle"
        }
      };

    // TODO: Handle "InReview" status when backend adds it
    // "InReview" means submitted and awaiting payer approval
    case "InReview" as WorkLogStatus:
      return {
        secondaryText: "Awaiting client approval",
        pill: {
          text: "Submitted",
          theme: "blue",
          icon: "send"
        }
      };

    // TODO: Handle "Rejected" status when backend adds it
    case "Rejected" as WorkLogStatus:
      return {
        secondaryText: "Rejected by client",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        secondaryText: "Awaiting your submission",
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
